export default __webpack_public_path__ + "static/media/img554.0663bb2b.JPG";